export default __webpack_public_path__ + "static/media/tesla.f3c1718f.png";